module.exports = __webpack_public_path__ + "img/shili_04@3x.d7c62a17.png";